// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__lVWok","label":"Completed_label__1bOGx"};